import React from 'react'

import Image from '@Pure/Image'
import Logo  from '@Pure/Logo'
import Link  from '@Pure/Link'

import bemit from '@function/bemit'

const { app } = window;

export default function PlaceSlideCard ({ place, ...props })
{
	let thumbnail;

	if (place.images?.[0]?.url)
	{
		thumbnail = place.images[0].url;
	}

	if (thumbnail)
	{
		thumbnail =
		(
			<Image className="c-model-preview__img" src={ thumbnail } />
		);
	}
	else
	{
		thumbnail =
		(
			<Logo className="c-model-preview__img default" type="svg"
				synergies={ true }
			/>
		);
	}

	let name = app.getTruncatedText(place.name, 60).toUpperCase();

	let output =
	(
		<div className={ bemit('c-model-preview-item', ['place', 'slider']) }
			key={ place.id }>

			<div className="c-model-preview c-model-preview--home">
				<div className="c-model-preview__thumb">
					<Link className="c-model-preview__thumb-link"
						href={ '/accueil/lieux/' + place.id }>
						{ thumbnail }
					</Link>
				</div>

				<div className="c-model-preview__content">

					<h2 className="c-model-preview__title">
						<Link href={ '/accueil/lieux/' + place.id }
							className="c-model-preview__title-link">
							{ name }
						</Link>
					</h2>

					<div className="c-model-preview__infos">

						<div className="c-model-preview__buttons">

							<Link href={ '/accueil/lieux/' + place.id }
								className="c-model-preview__link">
								<svg className="o-svg-icon o-svg-icon--eye c-model-preview__link-icon">
									<use xlinkHref="/images/icons.svg#svg-icon-eye"></use>
								</svg>Voir le lieu
							</Link>

						</div>

					</div>

				</div>

			</div>

		</div>
	);

	return output;
}